import React from 'react';
import Icon from '../../../components/AppIcon';

const AllergiesCard = ({ allergies }) => {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'Severe':
        return 'bg-destructive/10 text-destructive border-destructive/20';
      case 'Moderate':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'Mild':
        return 'bg-success/10 text-success border-success/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 border border-border p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
        <h3 className="text-base md:text-lg font-semibold text-foreground">Active Allergies</h3>
      </div>
      {allergies?.length === 0 ? (
        <div className="text-center py-6 md:py-8">
          <Icon name="CheckCircle" size={40} className="mx-auto mb-3 text-success" />
          <p className="text-sm md:text-base text-muted-foreground">No known allergies</p>
        </div>
      ) : (
        <div className="space-y-3">
          {allergies?.map((allergy, index) => (
            <div
              key={index}
              className={`p-3 md:p-4 rounded-lg border-2 ${getSeverityColor(allergy?.severity)}`}
            >
              <div className="flex items-start justify-between gap-2 mb-2">
                <h4 className="text-sm md:text-base font-semibold">{allergy?.allergen}</h4>
                <span className="text-xs font-medium px-2 py-1 bg-background/50 rounded whitespace-nowrap">
                  {allergy?.severity}
                </span>
              </div>
              
              <p className="text-xs md:text-sm opacity-90 mb-2">{allergy?.reaction}</p>
              
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Icon name="Calendar" size={12} />
                <span>Documented: {allergy?.documentedDate}</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AllergiesCard;